module.exports = __webpack_public_path__ + "static/media/1003048MF.d2966569.jpg";